import axios from "axios";
import { baseURL } from "../constants/url";
const instance = axios.create({
  // baseURL: "http://65.1.51.239/",
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor to attach the latest token before every request
instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export default instance;
